import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

interface IPublicRouteProps {
    element: React.ReactNode;
}

const PublicRoute = ({ element }: IPublicRouteProps) => {
    const token = Cookies.get('token');


    if (token) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{element}</>;
};

export default PublicRoute;
